<template><div><h1 id="gutscheintypen" tabindex="-1"><a class="header-anchor" href="#gutscheintypen"><span>Gutscheintypen</span></a></h1>
<p>Gutscheintypen — Bestimmung verschiedener Gutscheintypen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Dient zur Bestimmung verschiedener Gutscheine, die im System erfasst werden können. Pro Typ können bestimmte Finanzbuchhaltungskonten angesteuert werden.</p>
<p>Pfad: <code v-pre>Verkauf → Tabellen → Gutscheintypen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Nr.</dt>
<dd>Nummer des Gutscheintyps, 2-stellig; wird vom System automatisch vergeben, kann aber manuell beeinflusst werden</dd>
<dt>Wert</dt>
<dd>Wert eines Gutscheins in Franken, 4-stellig, max. 9999 Franken</dd>
<dt>Bezeichnung</dt>
<dd>Bezeichnung des Gutscheintyps</dd>
<dt>Art</dt>
<dd>Auftragsart. Sie hat für Gutscheine nur insofern Bedeutung, als die Zahlungsfrist für die Rechnung von dieser Auftragsart übernommen wird</dd>
<dt>LaufNum</dt>
<dd>Bestimmung der nächsten, gültigen Gutschein-Nummer für den Verkauf. Sie wird beim Verkauf automatisch erhöht</dd>
<dt>Ertragskonto</dt>
<dd>Konto, auf welches eingelöste Gutscheine verbucht werden sollen</dd>
<dt>ErtragsKst</dt>
<dd>Kostenstelle, auf welche eingelöste Gutscheine verbucht werden sollen</dd>
<dt>ErtragsKtr</dt>
<dd>Kostenträger, auf welchen eingelöste Gutscheine verbucht werden sollen</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/trade/auftragsverwaltung.html#Auftragsverwaltung" title="1. Auftragsverwaltung">Auftragsverwaltung</RouteLink></p>
</div></template>


